import type { Event } from '@cocoonspace/sdk-js/types/event'
import type { EventExtra } from '@cocoonspace/sdk-js/types/eventExtra'
import type { EventExtraChoiceItem } from '@cocoonspace/sdk-js/types/eventExtraChoiceItem'
import Markdown from 'react-markdown'
import { Card } from '@cocoonspace/ui/components/card'

import {
	ExtraSelectButton,
	ExtraUpdateButton,
} from '~/domains/extras/components/extra-details/actions-btns'
import { CompositionAndDelivery } from '~/domains/extras/components/extra-details/composition-and-delivery'
import { ExtraImages } from '~/domains/extras/components/extra-details/extra-images'
import { ExtraPrice } from '~/domains/extras/components/extra-details/extra-price'
import { ExtraTitle } from '~/domains/extras/components/extra-details/extra-title'
import { ExtraMenusChoices } from './extra-menus-choices'

export const ExtraDetails = ({
	extra,
	event,
	action = 'select',
	onActionClick,
	onMenuChange,
}: {
	extra: EventExtra
	event?: Pick<Event, 'extras_allowed_until'>
	action?: 'update' | 'select' | null
	onActionClick?: () => void
	onMenuChange?: (extraMenu: EventExtraChoiceItem) => void
}) => (
	<Card className='flex flex-col divide-y'>
		<div className='flex flex-col gap-4 p-4'>
			<div className='flex flex-col gap-4 md:flex-row md:items-center'>
				<div className='flex items-center gap-4'>
					<ExtraImages extra={extra} />

					<div className='flex flex-1 flex-col'>
						<ExtraTitle extra={extra} />
						<ExtraPrice extra={extra} />
					</div>

					{action === 'update' && (
						<div className='flex items-center gap-4'>x {extra.quantity}</div>
					)}
				</div>

				{action === 'select' && <ExtraSelectButton onClick={onActionClick} />}
				{action === 'update' && <ExtraUpdateButton onClick={onActionClick} />}
			</div>

			<div className='text-sm'>
				<Markdown>{extra.description}</Markdown>
			</div>
		</div>

		<CompositionAndDelivery extra={extra} />

		{action === 'update' && !!extra.choices?.length && onMenuChange && (
			<ExtraMenusChoices
				event={event}
				extra={extra}
				onMenuChange={onMenuChange}
			/>
		)}
	</Card>
)
